import { render, staticRenderFns } from "./FormPart2.vue?vue&type=template&id=b45c41f8&scoped=true"
import script from "./FormPart2.vue?vue&type=script&lang=js"
export * from "./FormPart2.vue?vue&type=script&lang=js"
import style0 from "./FormPart2.vue?vue&type=style&index=0&id=b45c41f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45c41f8",
  null
  
)

export default component.exports